import { makeStyles } from "@mui/styles";
import theme from "../../../../theme";

export const useStyles = makeStyles({
    friendsBlockWrapper: {
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateRows: "auto 1fr",
    },
    friendsScroll: {
        width: "100%",
        height: "100%",
    },
    listWrapper: {
        height: "100%",
        display: "grid",
        marginTop: 16,
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: 'column',
            marginTop: 0,
        },
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: 'column',
            marginTop: 0,
        },
    },
    itemWrapper: {
        width: '100%',
        display: "flex",
        alignItems: "center",
        borderRadius: 44,
        background: "#F5F5F50D",
        padding: 16,
        marginBottom: '1vw',
        justifyContent: 'space-between',
        [theme.breakpoints.down("md")]: {
            background: "transparent",
            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: 0,
            padding: '12px 0',

        },
        [theme.breakpoints.down("sm")]: {
            background: "transparent",
            borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: 0,
            padding: '12px 0',
            gap: 8,
        },
    },
    userInfoWrapper: {
        //width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flex: 1, 
        minWidth: 0, 
        [theme.breakpoints.down("sm")]: {
        //    width: "75%",
        },
    },

    avatarContainer: {
        position: "relative",  
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    avatarWrapper: {
        width: 49,
        height: 49,
        marginRight: 16,
    },

    starsOverlay: {
        position: "absolute",
        left: "50%",
        width: "120%", 
        height: "auto",
        pointerEvents: "none",  
    },


    userNameBox: {
        position: "relative",
        display: "flex", 
        overflow: "hidden", 
        whiteSpace: "nowrap", 
        maxWidth: "100%", 
    },

    userName: {
        fontSize: 18,
        fontWeight: 700,
        color: "#F5F5F5CC",
        overflow: "visible", 
        maxWidth: "100%",  
        whiteSpace: "nowrap", 
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
        },
    },

    marquee: {
        display: "inline-block",
        animation: "$marquee 7s linear infinite",
    },
    '@keyframes marquee': {
        '0%': {
            transform: 'translateX(100%)',
        },
        '10%': {
            transform: 'translateX(0%)',
        },
        '90%': {
            transform: 'translateX(-100%)',
        },
        '100%': {
            transform: 'translateX(-100%)',
        },
    },
    buttonWrapper: {
        //width: "90%",
        display: "flex",
        justifyContent: "flex-end",
        flexShrink: 0, 
        gap: 16,
        [theme.breakpoints.down("sm")]: {
            gap: 8,
        },
    },
    closeIcon: {
        width: 22,
        height: 22,
        fill: 'currentColor',
    },
    denyIcon: {
        width: 19,
        height: 22,
    },
    historyIcon: {
        width: '24px',
        height: '24px',
    },
    acceptIcon: {
        width: '20px',
        height: '20px',
    },
    mobileBtn: {
        background: 'transparent !important',
    },
    userDetailsWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        [theme.breakpoints.down("sm")]: {
            width: '55%',
        },
    },
    nameRatingWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
    },
    raitingTitle: {
        fontSize: 16,
        color: "#F5F5F5E5",
        [theme.breakpoints.down("md")]: {
            fontSize: 12,
            color: "#00BA6C",
            marginTop: '1vw',
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
            color: "#00BA6C",
            marginTop: '2vw',
        },
    },
    userRating: {
        fontSize: 14,
        fontWeight: 500,
        color: "#F5F5F5E5",
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    },
    userRatingTitle: {
        fontSize: 14,
        color: "#F5F5F5E5",
        fontWeight: 400,
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    },
    winsLossesWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25vw',
    },
    winsLossesColumn: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        fontSize: 14,
        fontWeight: 600,
        color: "#F5F5F5E5",
    },
    winsLossesBlock: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 'clamp(10px, 1.5vw, 14px)', 
    },
    winLossValue: {
        color: '#F5F5F5E5',
        fontWeight: 600,
        fontSize: 'inherit', 
    },
    winLossLabel: {
        fontWeight: 600,
        fontSize: 'inherit', 
    },
    userRank: {
        fontSize: 14,
        fontWeight: 600,
        color: "#F5F5F5CC",
    },
    rankBlock: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    rankIcon: {
        width: '24px',
        height: '24px',
        objectFit: 'contain',
    },
    statsRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5vw',
    },
    ratingBlock: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    ratingColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.2vw',
    },
    pendingRequestsWrapper: {
        color: '#fff',
        opacity: 1,
    },
    searchMessage: {
        padding: '10px',
        textAlign: 'start',
        color: 'rgba(245, 245, 245, 0.8)',
        fontSize: 24,
        fontWeight: 600,
    },

    mobileOverlay: {
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(18, 18, 18, 0.9)',
        zIndex: '99999 !important',
        height: 'calc(100vh - 130px)',
        marginBottom: '80px',
        width: '100%',
        borderTop: '1px solid #FFFFFF26',
        borderRadius: '15px 15px 0 0', 
        overflow: 'hidden',
        [theme.breakpoints.down("lg")]: {
            height: 'calc(100vh - 160px)',
        },
        [theme.breakpoints.down("md")]: {
            height: 'calc(100vh - 160px)',
        },
        [theme.breakpoints.down("sm")]: {
            height: 'calc(100vh - 130px)',
            marginBottom: '80px',
        },
    },
    mobileContainer: {
        backgroundColor: 'rgba(18, 18, 18, 0.9)',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    header: {
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'relative',
        gap: '1vw',
        [theme.breakpoints.down("sm")]: {
            //marginTop: '10vw',

        },
    },
    title: {
        display: 'flex',
        color: '#FFFFFF',
        fontSize: '18px',
        fontWeight: 400,
        flex: 1,
        textAlign: 'center',
        justifyContent: 'space-between',
    },
    closeButton: {
        position: 'absolute',
        right: '16px',
        background: 'none',
        border: 'none',
        color: '#FFFFFF',
        fontSize: '24px',
        cursor: 'pointer',
        padding: '5px',
        '&:hover': {
            opacity: 0.7,
        },
    },
    searchContainer: {
        padding: '12px',
    },
    searchInput: {
        width: '100%',
        backgroundColor: '#2D2D2D',
        border: '1px solid #404040',
        borderRadius: '8px',
        color: '#FFFFFF',
        padding: '12px',
        fontSize: '16px',
        '&::placeholder': {
            color: '#808080',
        },
    },
    content: {
        flex: 1,
        overflowY: 'auto',
        padding: 12,
        borderTop: '1px solid #FFFFFF26',
        [theme.breakpoints.down("md")]: {
            padding: 15,

        },
    },
    sectionTitle: {
        color: '#808080',
        fontSize: 14,
        marginBottom: 12,
        paddingLeft: 8,
    },
    pendingRequests: {
        marginBottom: 0,
    },
    noFriends: {
        color: '#808080',
        textAlign: 'center',
        padding: '40px 20px',
    },
    liveIconWrapper: {
        display: "flex",
        width: 45,
        //justifyContent: "center",
        //alignItems: "center",
        marginTop: "-18px", 
        marginLeft: 2,
    },

    liveIcon: {
        width: "100%",
        height: "auto",
        objectFit: "contain",
    },

});
